export const SOFTWARE_BASE_PRODUCT_KEYS = {
  SW_KIOSK: 'sw-kiosk',
};
